export default __webpack_public_path__ + "static/dns-ea24f5f9786861408009a37a71de250e.png";